module.exports = __webpack_public_path__ + "Seamless_WoodBG-f9925769aa13b171805626f8a16c64cb.svg";